// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WMComponent } from '@front/webmobile/Views/Components/WMComponent';
import { VerticalDetailsItemViewModel } from '../../../ViewModels/VerticalDetailsItemViewModel';
import React from 'react';
export class VerticalDetailsItem extends WMComponent {
    constructor(props) {
        super(props, (VerticalDetailsItemViewModel));
        this.onMouseDown = this.onMouseDown.bind(this);
    }
    onMouseDown(event) {
        this.viewModel.onMouseDown(event);
    }
    render() {
        const { rowName, rowNameTooltip, rowValueTooltip, firstRowValue, secondRowValue, firstValueColor, secondValueColor } = this.state;
        return (React.createElement("div", { className: "account-details-item", onMouseDown: this.onMouseDown },
            React.createElement("div", { className: "item-name", "data-tooltip": rowNameTooltip }, rowName),
            React.createElement("div", { className: "item-value", "data-tooltip": rowValueTooltip },
                React.createElement("div", { className: `value ${firstValueColor}` }, firstRowValue),
                secondRowValue && (React.createElement(React.Fragment, null,
                    React.createElement("div", null, "/"),
                    React.createElement("div", { className: `value ${secondValueColor}` }, secondRowValue))))));
    }
}
